module.exports = __webpack_public_path__ + "img/ConceptoMovil-G.6fa83037.png";